module.exports = __webpack_public_path__ + "static/red1-fd8d1151bac90125c712895338c98fce.png";